var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollTarget",attrs:{"id":"background"}},[_c('ReviewList',{attrs:{"reviews":_vm.reviews}}),_c('div',{staticStyle:{"visibility":"hidden"},attrs:{"id":"end"}},[_vm._v("리뷰 종료")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }